import { Format } from "../interfaces/Format";


export const INITIAL_VALUES: Format = {
  description: '',
  flag_id: '',
}
